import React, { ReactNode } from "react";
// import HeartSvg from "../../../icons/HeartSvg";
interface Props {
  className?: string;
  heading?: string;
  subheading?: string;
  //   tagBgClasses?: string;
  //   price?: string;
  //   address?: string;
  imageLink?: string;
  propertyLink?: string;
  icon?: React.ReactNode;
}

import { Button } from "../../../../shadcn/components/ui/button";

export const ExploreAuctionPropertiesCard = ({
  className,
  heading,
  subheading,
  //   tagBgClasses,
  //   price,
  //   address,
  imageLink,
  propertyLink,
  icon,
}: Props) => {
  return (
    <div className={`${className} relative`}>
      <img
        src={imageLink}
        className="max-w-[308px] max-h-[460px] lg:max-w-full lg:max-h-full lg:w-full"
        alt=""
      />
      <div className="absolute z-10 top-7 left-5 pr-3">
        <p className="font-openSans font-semibold text-[20px] lg:text-web-h3 leading-7 lg:leading-[38px] text-white">
          {heading}
        </p>
        <p className="max-w-[347px] mt-2 font-openSans font-normal text-mobile-body-sm lg:text-web-body-md leading-4 lg:leading-5 text-white">
          {subheading}
        </p>
      </div>
      <a href={propertyLink} className="absolute z-10 bottom-[26px] right-9">
        {icon}
      </a>
    </div>
  );
};
